import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedShape: '0000round',
  selectedCaratRange: '5.0-999.0',
  selectedClarity: 'IF',
  selectedColor: 'D',
  selectedCell: null
};

const higherOrderSlice = createSlice({
  name: 'higherOrder',
  initialState,
  reducers: {
    setSelectedShape: (state, action) => {
      state.selectedShape = action.payload;
    },
    setSelectedCaratRange: (state, action) => {
      state.selectedCaratRange = action.payload;
    },
    setSelectedCell: (state, action) => {
      state.selectedCell = action.payload;
    },
    setSelectedClarity: (state, action) => {
      state.selectedClarity = action.payload;
    },
    setSelectedColor: (state, action) => {
      state.selectedColor = action.payload;
    },
  }
});

export const {
  setSelectedShape,
  setSelectedCaratRange,
  setSelectedCell
} = higherOrderSlice.actions;

// Selectors
export const selectShapeCaratState = (state) => state.higherOrder;
export const selectSelectedShape = (state) => state.higherOrder.selectedShape;
export const selectSelectedCaratRange = (state) => state.higherOrder.selectedCaratRange;
export const selectSelectedCell = (state) => state.higherOrder.selectedCell;
export const selectSelectedClarity = (state) => state.higherOrder.selectedClarity;
export const selectSelectedColor = (state) => state.higherOrder.selectedColor;

export default higherOrderSlice.reducer;